import { requestAuthorized } from './index';
import { webApiEndpoint } from '../clientConfig';

export const fetchWidgets = () =>
  requestAuthorized({
    url: `${webApiEndpoint}/api/dashboard/widgets`,
    method: 'get',
  }).then((response) => response.data);
